/**
 * Constants for notifications feature
 * Centralized configuration values for consistent behavior across components
 */

import { capitalDesignTokens } from '@opengov/capital-mui-theme';

export const LIST_PANE_WIDTH_MIN = 400;
export const LIST_PANE_WIDTH_MAX = 480;

/**
 * Inbox/list divider stroke — Capital Storybook Divider color
 * (`MuiDivider` → semanticColors.border.secondary → foundations.colors.gray300).
 * Do not use MUI `palette.divider` (rgba black) here.
 */
export const INBOX_DIVIDER_COLOR = capitalDesignTokens.semanticColors.border.secondary;

/**
 * Query stale time in milliseconds
 * How long cached data is considered fresh before refetching
 */
export const QUERY_STALE_TIME_MS = 30 * 1000; // 30 seconds

/**
 * Query cache time in milliseconds
 * How long to keep inactive query data in cache
 */
export const QUERY_CACHE_TIME_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Polling interval in milliseconds
 * How often to refetch task and notification data in the background.
 * Stopgap until live server push (WebSockets/SSE) is available.
 */
export const POLLING_INTERVAL_MS = 30 * 1000; // 30 seconds

/**
 * MUI spacing units for inbox sort Select minWidth (theme.spacing(12) → 96px).
 * Shared by notifications and tasks sort dropdowns.
 */
export const INBOX_SORT_SELECT_MIN_WIDTH_SPACING = 12;
